import React from 'react';
import PropTypes from 'prop-types';
import Img from '../../../../Img';
import ToggleSwitch from './ToggleSwitch';
import styles from '../../collegeProspectTab.scss';

const CollegeRow = ({ college, onToggleAlert, onDelete, onShowAlertInfo }) => {
    const {
        id,
        name,
        logo,
        p6,
        division,
        conference,
        isAlerted = false,
    } = college;

    const logoUrl = logo || '/img/v2/icons/icon-avatar-college.svg';

    return (
        <div className={styles.collegeRow}>
            <div className={styles.collegeNameColumn}>
                <div className={styles.collegeLogo}>
                    <Img
                        src={logoUrl}
                        alt={name}
                        className={styles.collegeLogoImg}
                    />
                </div>
                <div className={styles.collegeName}>
                    {name}
                </div>
            </div>

            <div className={styles.collegeP6Column}>
                {p6 || '-'}
            </div>

            <div className={styles.collegeDivisionColumn}>
                {division || '-'}
            </div>

            <div className={styles.collegeConferenceColumn}>
                {conference || '-'}
            </div>

            <div className={styles.collegeAlertColumn}>
                <span className={styles.alertColumnInlineLabel}>
                    Alert College
                    {onShowAlertInfo && (
                        <button
                            type="button"
                            className={styles.alertInfoIconBtn}
                            onClick={onShowAlertInfo}
                            aria-label="What does Alert College do?"
                        >
                            <Img
                                src="/img/v4/info-icon.svg"
                                alt=""
                                className={styles.alertInfoIcon}
                            />
                        </button>
                    )}
                </span>
                <ToggleSwitch
                    id={id}
                    isOn={isAlerted}
                    onToggle={() => onToggleAlert(id)}
                />
            </div>

            <div className={styles.collegeDeleteColumn}>
                <button
                    type="button"
                    className={styles.deleteButton}
                    onClick={() => onDelete(id)}
                    aria-label="Delete college"
                >
                    <Img
                        src="/img/v2/icons/icon-close.svg"
                        alt="Delete"
                        className={styles.deleteIcon}
                    />
                </button>
            </div>
        </div>
    );
};

CollegeRow.propTypes = {
    college: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string.isRequired,
        logo: PropTypes.string,
        p6: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        division: PropTypes.string,
        conference: PropTypes.string,
        isAlerted: PropTypes.bool,
        dateLastAlerted: PropTypes.string,
    }).isRequired,
    onToggleAlert: PropTypes.func,
    onDelete: PropTypes.func,
    onShowAlertInfo: PropTypes.func,
};

CollegeRow.defaultProps = {
    onToggleAlert: () => {},
    onDelete: () => {},
    onShowAlertInfo: null,
};

export default CollegeRow;
